/* eslint-disable react/display-name */
/* eslint-disable react/prop-types */
import React from "react";
import { formatCurrency } from "../../../helpers";
import NumberCell from "../../tableFields/NumberCellNegative";

export const LEVEL_3_COLUMNS = [
  {
    Header: "Call Type",
    id: "call_type",
    accessor: "call_type.value",
    maxWidth: 120
  },
  {
    Header: "Year",
    accessor: "year",
    id: "year",
    maxWidth: 75
  },
  {
    Header: "Month",
    accessor: "month",
    id: "month",
    maxWidth: 75
  },
  {
    Header: "Department",
    accessor: "department.description",
    id: "department"
  },
  {
    Header: "Contract",
    accessor: "contract",
    id: "contract"
  },
  {
    Header: "Project",
    accessor: "project",
    id: "project"
  },
  {
    Header: "Employee",
    accessor: "assigned_to.full_name",
    id: "employee",
    maxWidth: 150
  },
  {
    Header: "Hours",
    accessor: "billable_hrs",
    id: "billable_hrs",
    maxWidth: 75,
    Cell: ({ value }) =>
      Number(value)?.toFixed(2) !== "NaN" ? Number(value)?.toFixed(2) : "0.00"
  },
  {
    Header: "Rate",
    accessor: "rate",
    id: "rate",
    maxWidth: 75,
    Cell: ({ value }) => `$${value}`
  },
  {
    Header: "Total",
    accessor: "total",
    id: "total",
    maxWidth: 75,
    Cell: ({ value }) => `$${value}`
  },
  {
    Header: "Prepaid Balance",
    accessor: "hours_balance",
    id: "hours_balance",
    maxWidth: 75,
    Cell: ({ value }) => (
      <NumberCell getValue={(val) => val.toFixed(2)} value={value} />
    )
  },
  {
    Header: "% Purch Bal",
    accessor: "percent_balance",
    id: "percent_balance",
    maxWidth: 100,
    Cell: ({ value }) =>
      value === "0.00" ? (
        <NumberCell
          getValue={(val) => `${val}%`}
          value={value}
          threshold={-1}
        />
      ) : (
        <NumberCell
          getValue={(val) => (val ? `${val}%` : "")}
          value={value || ""}
          threshold={20}
        />
      )
  }
];

export const LEVEL_2_COLUMNS = [
  {
    Header: "Call Type",
    id: "call_type",
    accessor: "call_type.value",
    maxWidth: 150
  },
  {
    Header: "Year",
    accessor: "completed_date",
    id: "year",
    Cell: ({ value }) => (value ? new Date(value).getFullYear() : "--"),
    maxWidth: 75
  },
  {
    Header: "Month",
    accessor: "completed_date",
    id: "month",
    Cell: ({ value }) => (value ? new Date(value).getMonth() + 1 : "--"),
    maxWidth: 75
  },
  {
    Header: "Department",
    accessor: "department.description",
    id: "department"
  },
  {
    Header: "Customer - Contract",
    accessor: "customer.name",
    id: "customer_contract",
    Cell: ({ value, original }) =>
      `${value} - ${original?.contract?.contract_type?.label}`
  },
  {
    Header: "Hours",
    accessor: "billable_hrs",
    id: "billable_hrs",
    maxWidth: 75,
    Cell: ({ value }) =>
      Number(value)?.toFixed(2) !== "NaN" ? Number(value)?.toFixed(2) : "0.00"
  },
  {
    Header: "Total",
    accessor: "total",
    id: "total",
    maxWidth: 75
  },
  {
    Header: "Prepaid Balance",
    accessor: "prepaid_balance",
    id: "prepaid_balance",
    maxWidth: 170,
    Cell: ({ value }) => (
      <NumberCell
        getValue={(val) => formatCurrency(val || 0)}
        value={value || 0}
      />
    )
  },
  {
    Header: "% Purch Bal",
    accessor: "purch_bal",
    id: "purch_bal",
    maxWidth: 100,
    Cell: ({ value }) => (
      <NumberCell getValue={(val) => `${val.toFixed(2)}%`} value={value || 0} />
    )
  }
];

export const LEVEL_1_COLUMNS = [
  {
    Header: "Call Type",
    id: "call_type",
    accessor: "call_type.value",
    maxWidth: 150
  },
  {
    Header: "Year",
    accessor: "completed_date",
    id: "year",
    Cell: ({ value }) => (value ? new Date(value).getFullYear() : "--"),
    maxWidth: 75
  },
  {
    Header: "Month",
    accessor: "completed_date",
    id: "month",
    Cell: ({ value }) => (value ? new Date(value).getMonth() + 1 : "--"),
    maxWidth: 75
  },
  {
    Header: "Department",
    accessor: "department.description",
    id: "department"
  },
  {
    Header: "Total",
    accessor: "total",
    id: "total",
    maxWidth: 100,
    Cell: ({ value }) => (value ? `$${value}` : "$0")
  }
];
